module.exports = __webpack_public_path__ + "media/images/top/voice/voice1-fe09aa4c3a629fd2e6097904ab0cfda8.png";